import React from "react";
import Modal from "react-modal";
import EditProfileForm from "../forms/EditProfileForm.jsx";
import { useDispatch, useSelector } from "react-redux";
import { customerSelector } from "../selector";
import { toggleEditModel } from "../action";
import { updateAddressAndPhoneNum } from "../thunk";

const ProfileEditModal = () => {
  const dispatch = useDispatch();
  const customer = useSelector((state) => customerSelector(state));

  return (
    <Modal
      className="Modal__Bootstrap modal-dialog"
      closeTimeoutMS={150}
      isOpen={customer.editModel}
      contentLabel="Customer Profile"
    >
      <div className="modal-content modal-content-padding">
        <div className="modal-header mar-t-5">
          <div className="acct-modal-close-btn">
            <i
              className="fa fa-times"
              aria-hidden="true"
              onClick={() => dispatch(toggleEditModel())}
            ></i>
          </div>
          <div className="acct-modal-heading">Edit Profile</div>
          <div className="acct-modal-hr"></div>
        </div>
        <div
          className="modal-body modal-body-padding"
          style={{ fontSize: "14px" }}
        >
          <div>
            <EditProfileForm
              closeEditProfileModal={() => dispatch(toggleEditModel())}
              updateCustomerProfile={(customerDetails) =>
                dispatch(updateAddressAndPhoneNum(customerDetails))
              }
              customerId={customer.id}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export { ProfileEditModal };
